export const coachingTypes: {
  label: string;
  value: string;
}[] = [
  {
    label: "Einzelcoaching",
    value: "503cec4e-62da-46db-8833-4ec3f44736eb",
  },
  {
    label: "Speedcoaching",
    value: "5fcd7dda-2b9b-4374-80a3-8f2cadae84ba",
  },
];
